<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">栄枯盛衰のClubhouse——自由で新鮮な体験が売りの音声SNSは、もはや「つるはし売り」の場に?</h1>
                <span class="meta"> Posted in April 2021 </span>

                <p class="author-info ">Mark Bivens is a Silicon Valley native and former entrepreneur, having started three companies before becoming a VC. He is the Managing Partner of Shizen Capital (formerly known as Tachi.ai Ventures) in Japan. You can read more on his blog at <a href="http://markbivens.com">http://rude.vc</a> or follow him on Twitter <a href="https://twitter.com/markbivens">@markbivens</a>.</p>

                <figure>
                  <img class="img-fluid" src="img/blog/card/clubhouse-japan.jpg" alt="">
                </figure>
                
                <p>昨日、日本における Clubhouse の盛衰について興味深い議論をしていた。幸運なことに、日本での現象をよりよく理解している2人の方から教えていただくことができた。</p>

                <p>Clubhouse は1月下旬に日本でローンチし、Apple App Store で無料アプリの第1位に躍り出た。<a href="https://asia.nikkei.com/Business/Technology/Japan-lawmakers-join-Clubhouse-app-to-reach-voters">政治家も使い始めた。</a></p>

                <p>それからわずか2ヶ月で、Clubhouse は、今は亡きプロ野球選手 Yogi Berra 氏の名言を具現化したような存在になってしまった。「<a href="https://quoteinvestigator.com/2014/08/29/too-crowded/">あそこに行く気になる人はもういないはずだ。人が多すぎてね。</a>」</p>

                <h2 class="section-heading">なぜ Clubhouse は日本で火がついたのか？</h2>
                
                <p>日本はさまざまな意味で Clubhouse にとって理想的な市場だ。誰もがスマートフォンを持っていて、高速鉄道や地下鉄でも、信頼性の高い 4G（現在は多くの場所で 5G）のネットワークに接続されている。もちろん、パンデミックの際には、在宅勤務に一部移行したことで Clubhouse に逃げ込む好機となった。しかし、日本では大規模災害よりも新型コロナウイルスの方が不便を強いられたため、多くの人がオフィスで働いた。そのような人たちにとっては、長い通勤時間や、上司が帰る前にオフィスを出るというタブーが組み合わさって、時間をつぶすための十分な機会となっている。</p>
                
                <p>また、Clubhouse の持つ高級感は、日本の消費者にとっても魅力的だ。Trader Joe’s（アメリカのオーガニック食料品スーパーマーケット）の買い物袋を持って東京を歩けば、最近アメリカに行ったことがさりげなく伝わるように、シリコンバレーの権威ある招待制スマートフォンアプリに参加し、それをソーシャルメディアで発表することは、日本では深刻な FOMO（取り残される不安・恐怖）を生み出す。</p>


                <h2 class="section-heading">では、なぜそれが消えてしまったのか</h2>

                <p>日本において Clubhouse FOMO の舞台となった主なメディアは Facebook であり、Twitter もある程度利用されていたが、LinkedIn は利用されていなかった。日本のビジネスプロフェッショナルは、LinkedIn よりも Facebook を多く利用している。Facebook は、サラリーマン、フリーランス、起業家、投資家にとって、友人関係だけでなく、仕事上のつながりを持つための主要なソーシャルネットワークとして機能している。Facebook の月間アクティブユーザ数は2,600万人だ。日本の VC の中で Facebook をやっていないのは私だけだと言われたこともある（おそらく私にとっては不利益なことだが、申し訳ないが一線を画している）。</p>

                <p>一方、LinkedIn は10年近く前に日本に進出したにもかかわらず、日本でのアクティブユーザ数は現在でも数百万人程度だ。プロフェッショナル層の間で人気を集めている LinkedIn だが、日本では長い間、LinkedIn にアカウントを作成することに意味があった。これは、忠誠心と終身雇用を重んじる日本の大企業では、キャリアを損なう可能性のある行動だ（編注：転職活動をしていると見られるため）。</p>

                <p>Facebook の問題点は（というか、一つの問題点だが）、ジャンクが多いことだ。そのため、 Clubhouse は日本での成功の犠牲になっていると言える。 Clubhouse のメンバーシップは主に Facebook を通じて広まったため、誰でも参加でき、誰もが参加し、あらゆる種類の思想的指導者のたわごとを広めることになった。</p>

                <p>これと同じ現象を私はフランスで目の当たりにしたが、それは Cédric Giorgi 氏の素晴らしい、生意気なツイートに簡潔にまとめられている。</p>

                <p><blockquote class="twitter-tweet"><p lang="fr" dir="ltr">J&#39;adore Clubhouse, vraiment je suis fan de ce nouveau réseau et des conversations et échanges qui y ont lieu. Mais c&#39;est en train de devenir le royaume des infopreneurs, des vendeurs de pioche, des business coachs and co. et c&#39;est beaucoup trop tôt pour ça !</p>&mdash; Cédric Giorgi (@cgiorgi) <a href="https://twitter.com/cgiorgi/status/1361330196599693314?ref_src=twsrc%5Etfw">February 15, 2021</a></blockquote></p>
                <p>（訳）私は Clubhouse が大好きだ。この新しいネットワークとそこで交わされる会話や交流が本当に好きだ。しかし、それはインフォプレナーやつるはし売り、ビジネスコーチなどのための場所になりつつある。そうなるには、あまりにも早過ぎた。</p>

                <p>しかし、フランスの Clubhouse が「vendeurs de pioche（つるはし売り）」に蹂躙されるまでには、数ヶ月を要したようだ。日本では3週間しかかからなかった。</p>
                <p>訳注：「つるはし売り」とは、「ゴールドラッシュの時、最も金持ちになったのは金を掘る人ではなく、シャベルやつるはしを売る人だった」とする話に由来し、ここでは起業家が成長するための道具だとして、起業家に成功の方法を伝授すると吹聴し、その対価に高額な費用を請求する情報商材屋を揶揄している。 </p>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
